import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardLayoutComponent } from 'src/app/shared/layout/dashboard-layout/component/dashboard-layout.component';
import { RouterModule } from '@angular/router';
import {
  AuthenticationLayoutComponent
} from "src/app/shared/layout/authentication-layout/component/authentication-layout.component";

@NgModule({
  declarations: [
    AuthenticationLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports:[AuthenticationLayoutComponent]
})
export class AuthenticationLayoutModule { }
